import React from 'react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { classes } from './ServiceInfo.st.css';
import { ViewModel } from '../../../../controller/viewModel/viewModel';
import { ServiceDescription } from './ServiceDescription/ServiceDescription';
import { ServiceTitle } from './ServiceTitle/ServiceTitle';
import { ServiceNumber } from './ServiceNumber/ServiceNumber';
import { NEW_SERVICES_PAGE_EXPERIMENT } from '../../../../consts';

export const ServiceInfo: React.FC<{
  service: ViewModel['bodyViewModel']['services'][number];
  index: number;
}> = ({ service, index }) => {
  const { experiments } = useExperiments();
  const isServicesPageEnabled = experiments.enabled(
    NEW_SERVICES_PAGE_EXPERIMENT,
  );

  return (
    <div data-id={service.id} role="group" className={classes.root}>
      {isServicesPageEnabled ? (
        <div className={classes.header}>
          <ServiceNumber index={index} />
          <ServiceTitle title={service.name} />
        </div>
      ) : (
        <ServiceTitle title={service.name} />
      )}

      {service.description && (
        <ServiceDescription description={service.description} />
      )}
    </div>
  );
};
